module.exports = __webpack_public_path__ + "img/fullscreen_icon.cae418c3.svg";